import React from 'react'

const LoadingSpinner = ({ size = '3rem' }) => (
  <div className="d-flex justify-content-center my-3">
    <div className="spinner-border text-primary" role="status" style={{ width: size, height: size }}>
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
)

export default LoadingSpinner
